<template>
  <div class="ms-timepicker ms-editor w-100" @mouseover="onMouseover" @mouseout="onMouseout">
    <!-- <ms-tooltip :tooltip="tooltip">
      <div v-if="title" class="flex">
        <div v-if="title" class="ms-input-title">{{ title }}</div>
        <div v-if="required && requiredVisible" style="color: red">&nbsp;{{ textRequired }}</div>
      </div>
    </ms-tooltip> -->
    <div
      ref="parentElement"
      class="ms-container--timepicker flex-row"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <input
        v-bind="$attrs"
        v-model="innerValue"
        v-imask="mask"
        :disabled="disabled"
        :class="[
          {
            'ms-input-focus': isFocus,
            'ms-input-hoverx': hoverx,
            hasValue: innerValue !== '',

            placehoder: true,
            'ms-input-validate-error': valid === false,
          },
          {disabled: disabled},
        ]"
        :placeholder="placeholder"
        :title="errors ? errors[0] : ''"
        :type="$attrs.type ? $attrs.type : 'text'"
        class="ms-input--timepicker flex"
        @complete="onComplete"
        @accept="onAccept"
        @blur="onBlur($event, valid, errors)"
        v-on="listeners"
      />
      <div ref="icon" :class="['ms-clock', {disabled: disabled}, {'event-none': readOnly}]" @click="toggleClick"></div>
    </div>

    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
    <slot name="error"></slot>

    <div ref="timepickerContent" class="timepicker-content">
      <!-- :style="{ top: top, left: left, width: width, height: height }" -->
      <timepicker
        v-if="isShowTimePicker"
        v-model="valueDatePicker"
        :value="valueDatePicker"
        ref="timepicker"
        class="timepicker"
        @close.stop="updateDatePicker"
        @hide.stop="isShowTimePicker = false"
        @input="handleInput"
        @hideForm="
          () => {
            isShowTimePicker = false;
          }
        "
      ></timepicker>
    </div>
  </div>
</template>

<script>
import MsBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import IMask from 'imask';
import {IMaskDirective} from 'vue-imask';
import Timepicker from './Timepicker.vue';
import {reactive} from 'vue';
export default {
  name: 'MsTime',
  directives: {
    imask: IMaskDirective,
  },
  components: {
    Timepicker,
  },
  extends: MsBaseComponent,
  inject: {
    elForm: {
      default: '',
    },
    elFormItem: {
      default: '',
    },
  },
  inheritAttrs: false,
  props: {
    oldValue: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    modelValue: {
      required: false,
      // default: new Date(),
    },
    placeholder: {
      default: null,
      type: [String, Number],
    },

    title: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    textRequired: {
      type: String,
      default: '*',
      required: false,
    },
    /**
     * Có hiển thị ký tự required ra không
     */
    requiredVisible: {
      type: Boolean,
      default: false,
    },
    warningText: {
      type: String,
      default: 'Textbox này không được để trống',
    },

    /**
     * Các rule phục vụ cho validate control
     */
    rules: {
      type: [Object, String],
      default: '',
    },
    /**
     * id của validator provider
     */
    vid: {
      type: String,
    },
    errorMessage: {
      type: String,
      default: '',
    },

    valid: {
      type: Boolean,
      default: true,
    },

    errors: {
      type: [Array, String],
      default: '',
    },

    // /**
    //  * remember state of validate provider
    //  */
    // vPersist: {

    // }
    // add by dxtruong
    typeInput: {
      default: null,
      type: String,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },
  },
  data: function () {
    return {
      mask: {
        mask: 'H{:}M{:}S',
        lazy: false,
        blocks: {
          H: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
            maxLength: 2,
          },
          M: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2,
          },
          S: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2,
          },
        },

        overwrite: true,
        autofix: false,
      },
      innerValue: this.value,
      isFocus: false,
      isWarning: false,
      hasWarning: false,
      screenX: '',
      screenY: '',
      heightEl: '',
      width: '',
      screenParentX: '',
      screenParentY: '',
      styleTamGiac: {left: '10px'},
      hoverx: false,
      isShowTimePicker: false,
    };
  },
  computed: {
    isAfter() {
      return this.isWarning ? true : this.iconAfter;
    },
    isNoBorder() {
      return this.isWarning ? true : this.iconNoBorder;
    },
    styleWarning() {
      // tinh vi tri tooltip
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let top = '-20px';
      if (this.screenY > height - this.heightEl) {
        top = 20 + 'px';
      } else {
        top = -20 + 'px';
      }
    },

    listeners() {
      return {
        ...this.$listeners,
        input: evt => {
          // if (this.readOnlyState) {
          // 	evt.preventDefault();
          // 	return;
          // }
          this.$emit('input', evt.target.value);
          this.$emit('update:modelValue', this.innerValue);
        },
        focus: evt => {
          this.hoverx = false;
          this.hasWarning = false;
          this.isWarning = false;
          this.$emit('focus', evt);
          this.changeFocus(true);

          //  Nếu đang show timepicker ẩn đi
          if (this.isShowTimePicker) {
            this.isShowTimePicker = false;
          }
        },

        mouseover: evt => {
          this.hoverx = true;
        },
        mouseout: evt => {
          this.hoverx = false;
        },
      };
    },

    isValue() {
      return this.labelPlaceholder ? true : !this.innerValue;
    },
    getIcon() {
      return this.danger
        ? this.valIconDanger
        : this.warning
        ? this.valIconWarning
        : this.success
        ? this.valIconSuccess
        : '';
    },
    /**
     * Buid động validation rules theo config của control
     */
    validateRules() {
      const me = this;
      let rules = me.rules;

      if (!rules) {
        rules = '';
      }

      if (me.required) {
        rules = me.appendRuleValidation('required', rules);
      }
      return rules;
    },
  },
  watch: {
    innerValue(val, old) {
      // if (this.readOnlyState) {
      //   // evt.preventDefault();

      //   return;
      // }
      if (this.maxLength) {
        if (val.length > parseInt(this.maxLength)) {
          this.innerValue = old;
          this.$emit('input', old);
          return;
        }
      }
      this.$emit('input', val);
    },
    value(val) {
      this.innerValue = val;
    },
    modelValue(val) {
      this.innerValue = val;
    },
  },

  mounted() {
    this.heightEl = this.$el.offsetHeight;
    this.width = this.$el.offsetWidth;
    this.screenParentX = this.$refs.parentElement.getBoundingClientRect().left;
    this.screenParentY = this.$refs.parentElement.getBoundingClientRect().top;

    // //  Defaut giá trị giờ hiện tại
    // this.$nextTick(() => {
    //   this.innerValue = this.modelValue ?? '__:__:__';
    // });
  },

  beforeUnmount() {
    const me = this;
    me.isShowTimePicker = false;
  },

  methods: {
    onComplete(e) {
      this.innerValue = e.detail.unmaskedValue;
      e.detail.updateValue();
      this.$emit('input', this.innerValue);
    },
    onAccept() {},
    // animation
    onBlur: function (evt, valid, err) {
      // if (this.readOnlyState) {
      // 	evt.preventDefault();
      // 	return;
      // }
      this.hoverx = false;
      if (this.required && (!this.$props.value || this.$props.value.length === 0)) {
        this.isWarning = true;
      } else {
        this.isWarning = false;
      }
      this.$emit('blur', evt);
      this.changeFocus(false);
      if (valid === false) {
        this.$emit('validationError', err);
      }
    },
    changeFocus(booleanx) {
      this.isFocus = booleanx;
    },
    beforeEnter(el) {
      el.style.height = 0;
    },
    enter(el, done) {
      const h = el.scrollHeight;
      el.style.height = h + 'px';
      done();
    },
    leave: function (el) {
      el.style.height = 0 + 'px';
    },
    focusInput() {
      this.$refs.msinput.focus();
    },
    onMouseover(event) {
      if (this.isWarning) {
        this.hasWarning = true;

        this.screenX = event.screenX;
        this.screenY = event.screenY;
      }
    },
    onMouseout() {
      this.hasWarning = false;
    },

    // setReadOnlyCustom: function(readOnly){
    //   console.log("MsInput.setReadOnlyCustom")
    // }
    // add by dxtruong
    iconClick() {
      // this.$refs.msinput.focus();
      if (this.typeInput != null && this.typeInput === 'inputSearch') {
        this.$emit('iconClick');
      }
    },

    toggleClick() {
      if (this.disabled) {
        return;
      }
      //  Set lại giá trị cho valueDatePicker
      this.valueDatePicker = this.getDateFromValue(this.innerValue);

      this.isShowTimePicker = !this.isShowTimePicker;
    },

    /**
     * Xử lý khi chọn giờ
     */
    handleInput(value) {
      //  Kiểm tra nếu value có giá trị và là kiểu Date
      if (value && value instanceof Date) {
        //  Hiển thị giờ
        this.innerValue = this.getValueFromDate(value);

        this.valueDatePicker = value;

        this.$emit('update:modelValue', this.innerValue);
      }
    },

    /**
     * Lấy giá trị dang `${hour}:${minute}:${second}` từ  Date truyền vào
     */
    getValueFromDate(date) {
      if (date && date instanceof Date) {
        //  Lấy giờ
        let hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        //  Lấy phút
        let minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        //  Lấy giây
        let second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        //  Hiển thị giờ
        return `${hour}:${minute}:${second}`;
      }
      return '00:00:00';
    },

    /**
     * Lấy ra giá trị Date từ dang `${hour}:${minute}:${second}`
     */
    getDateFromValue(value) {
      if (value) {
        let [hours, minutes, seconds] = value.split(':');

        let date = new Date();
        date.setHours(hours || 0);
        date.setMinutes(minutes || 0);
        date.setSeconds(seconds || 0);
        return date;
      }

      return new Date();
    },
  },
};
</script>
<style></style>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTime.scss';
@media screen and (max-width: 1366px) {
  @import '@/assets/scss/components/MsInput.scss';
}
@media screen and (min-width: 1367px) {
  @import '@/assets/scss/components/MsInput.scss';
}
</style>
